import * as types from '../types';

const state = {
  scrollTop: 0,
};

const mutations = {
  [types.DOC_SCROLL_V] (state, scrollTop) {
    state.scrollTop = scrollTop;
  },
};

export default {
  state,
  mutations
};